import { track } from "../lib/track";
import { useApp } from "../state/AppState";
import { defilerVers } from "../lib/defiler";

const LIENS: ReadonlyArray<readonly [string, string]> = [
  ["diagnostic", "Le diagnostic"],
  ["comparatif", "Pourquoi nous"],
  ["methode", "Méthode"],
  ["tarifs", "Tarifs"],
];

/**
 * Fait revenir à l'accueil puis défile jusqu'à la section demandée. Les
 * sections d'accueil ne sont montées que sur la vue `home`.
 */
export function useScrollToSection(): (id: string) => void {
  const { view, goTo } = useApp();
  return (id: string) => {
    // Depuis une page hors parcours, la section n'est pas montée : on revient
    // à l'accueil avec l'ancre plutôt que de ne rien faire.
    if (window.location.pathname !== "/") {
      window.location.assign(`/#${id}`);
      return;
    }
    if (view !== "home") goTo("home");
    // `defilerVers` consulte `prefers-reduced-motion` — ce crochet sert la
    // barre **et** le pied de page, donc l'oubli s'y écrivait une fois et se
    // rendait trois. Voir `lib/defiler.ts`.
    requestAnimationFrame(() => defilerVers(id));
  };
}

export function Nav() {
  const { goTo, dirigeantActif } = useApp();
  const scrollTo = useScrollToSection();

  return (
    <header className="nav">
      <div className="shell nav-in">
        {/*
          La signature ne s'écrit pas dans la barre : à trois cent soixante
          pixels, elle chasserait le bouton d'action, qui est le geste que la
          barre existe pour porter. Elle vit au pied de page, sur l'image de
          partage et sur la couverture des rapports — et ici dans le libellé
          accessible, où elle ne coûte pas un pixel.
        */}
        <button
          type="button"
          className="logo"
          aria-label="STRATERA — tâche par tâche. Retour à l'accueil"
          onClick={() => goTo("home")}
        >
          STRATERA
        </button>
        <nav className="nav-links">
          {LIENS.map(([id, libelle]) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(id);
              }}
            >
              {libelle}
            </a>
          ))}
          {/*
            L'axe dirigeant était invisible depuis le menu : sa seule porte
            était la ligne de bifurcation sous le champ métier de l'accueil,
            alors que l'arbitrage du 18/08 en fait le canal d'acquisition
            premier. Une vraie adresse, pas une ancre : /dirigeant est une page.
            (Les liens du menu sont masqués sous 860 px — sur téléphone, la
            bifurcation d'accueil et le pied de page portent l'entrée.)
          */}
          {dirigeantActif && (
            <a
              href="/dirigeant"
              onClick={() => track("cta_click", { from: "nav-entreprises" })}
            >
              Entreprises
            </a>
          )}
        </nav>
        <button
          type="button"
          className="nav-cta"
          onClick={() => {
            track("cta_click", { from: "nav-cta" });
            goTo("s-t1");
          }}
        >
          Lancer le diagnostic
        </button>
      </div>
    </header>
  );
}
